<template>
  <span class="tw-bg-blue-100 tw-text-blue-gray-700" :style="{ width: '24px', height: '24px' }">
    <span>{{ content }}</span>
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'Não Identificado',
    },
  },
  computed: {
    content() {
      const arr = this.name.toUpperCase().split(' ')
      return `${arr[0][0]}${arr[1] ? arr[1][0] : arr[0][1]}`
    },
  },
}
</script>

<style scoped>
span {
  width: 24px;
  height: 24px;
  padding: 6px;
  font-weight: 500;
  font-size: 10px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
